var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('div',{staticClass:"material-icons md-16 w-100",class:_vm.dynamicClass},[_vm._v("\n  "+_vm._s(_vm.icon)+"\n")]):_c('div',{staticClass:"not-set w-100",class:_vm.dynamicClass},[_vm._v("\n  "+_vm._s(_vm.notSet)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }